import * as React from "react";
import type { Channel } from "../types";

const LOGO_SIZE = 44;
const LOGO_SIZE_COMPACT = 32;

function ChannelMark({ channel, size }: { channel: Channel; size: number }) {
  const [failed, setFailed] = React.useState(false);

  if (channel.logoUrl && !failed) {
    return (
      <img
        src={channel.logoUrl}
        alt=""
        draggable={false}
        onError={() => setFailed(true)}
        className="shrink-0 object-contain"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      aria-hidden
      className="flex shrink-0 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-primary-foreground"
      style={{ width: size, height: size }}
    >
      {channel.logo}
    </div>
  );
}

/** compact drops the name/"24/7 Channel" text and shrinks the mark, for the
 * narrow label column a phone screen gets (see TimelineGrid/WeekGrid): the
 * full label ate most of a phone's width, leaving only an hour or two of
 * the actual timeline visible. */
export function ChannelLabel({ channel, compact = false }: { channel: Channel; compact?: boolean }) {
  return (
    <div className="flex items-center" style={{ gap: compact ? 0 : 12 }} title={compact ? channel.name : undefined}>
      <ChannelMark channel={channel} size={compact ? LOGO_SIZE_COMPACT : LOGO_SIZE} />
      {compact ? null : (
        <div>
          <div className="text-base font-bold leading-tight text-foreground">{channel.name}</div>
          <div className="text-xs text-muted-foreground" style={{ marginTop: 2 }}>
            24/7 Channel
          </div>
        </div>
      )}
    </div>
  );
}
